import { Store } from '@reduxjs/toolkit';
import * as React from 'react';
import { IState } from 'shared/store';

import { useAuthenticationSubscription } from '../../hooks/useAuthenticationSubscription';

interface ISubscriptionsContainerProps {
  reduxStore: Store<IState>;
}

export const SubscriptionsContainer: React.FC<ISubscriptionsContainerProps> = ({ reduxStore }) => {
  useAuthenticationSubscription({ reduxStore });

  return null;
};
